import { defineMessages } from 'react-intl';
export var linkMessages = defineMessages({
    openLink: {
        id: 'fabric.editor.openLink',
        defaultMessage: 'Open link in a new tab',
        description: 'Opens the link in a new tab',
    },
});
//# sourceMappingURL=link.js.map